module.exports = __webpack_public_path__ + "static/media/fly0006.6983390c.webp";